import { gql } from "@apollo/client";

export const QUERY_FORM3454V_VERSION = gql`
  query studentForm3454V(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3454V(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      studentDob
      verbalStudentNeeds
      verbalSupportsIdentified
      socialStudentNeeds
      socialSupportsIdentified
      sensoryStudentNeeds
      sensorySupportsIdentified
      environmentalStudentNeeds
      environmentalSupportsIdentified
      activitiesStudentNeeds
      activitiesSupportsIdentified
      behavioralStudentNeeds
      behavioralSupportsIdentified
      otherStudentNeeds
      otherSupportsIdentified
      formAction
      formStatus
    }
  }
`;
